<template>
  <div class="card card-admin">
    <div class="card-body">
      <div class="form-group">
        <img class="img-thumbnail image-preview" :src="editedProduct.image_url" v-if="editedProduct.image_url"
          alt="Anteprima immagine" />
        <p style="text-align: center;" v-else>Anteprima immagine non disponibile</p>
      </div>
      <div class="form-group">
        <label for="name">Nome prodotto:</label>
        <input type="text" class="form-control" id="name" v-model="editedProduct.name"
          placeholder="Inserisci il nome del prodotto">
      </div>
      <div class="form-group">
        <label for="description">Descrizione:</label>
        <textarea class="form-control" id="description" v-model="editedProduct.description"
          placeholder="Inserisci la descrizione del prodotto"></textarea>
      </div>
      <div class="form-group">
        <label for="price">Prezzo:</label>
        <input type="text" class="form-control" id="price" v-model="editedProduct.price"
          placeholder="Inserisci il prezzo del prodotto">
      </div>
      <div class="form-group">
        <label for="category">Categoria</label>
        <input type="text" class="form-control" id="category" v-model.trim="editedProduct.category"
          placeholder="Inserisci la categoria">
      </div>
      <div class="form-group">
        <ImageUploader @image-selected="handleFileSelected"></ImageUploader>
      </div>

      <div class="button-group">
        <button class="btn btn-primary apply-button" @click="handleApplyChanges">Applica modifiche</button>
        <button class="btn btn-danger delete-button" @click="showConfirmationPopup">Elimina prodotto</button>
      </div>
      <div v-if="showModal" class="modal-container">
        <GenericModal message="Sei sicuro di voler eliminare questo piatto?" @confirmed="handleDeleteProduct"
          @canceled="hideConfirmationPopup"></GenericModal>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteDish, updateDish } from '@/api/DishesAPI';
import { uploadImage, deleteImageByUrl } from '@/utils/firebaseImageUploader';
import ImageUploader from '@/components/adminpage/ImageUploader.vue';
import GenericModal from '@/components/adminpage/GenericModal'

export default {
  components: {
    ImageUploader,
    GenericModal,

  },
  props: {
    product: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      editedProduct: { ...this.product },
      showModal: false
    };
  },
  methods: {
    handleFileSelected(file) {
      this.editedProduct.image_url = file;
    },
    showConfirmationPopup() {
      this.showModal = true;
    },
    hideConfirmationPopup() {
      this.showModal = false;
    },
    async handleDeleteProduct() {
      this.hideConfirmationPopup();
      if (this.editedProduct.image_url) {
        await deleteImageByUrl(this.editedProduct.image_url);
      }
      await deleteDish(this.editedProduct.id);
      this.$emit('refresh-products');
    },
    async handleApplyChanges() {
  if (this.editedProduct.image_url !== this.product.image_url) {
    if (this.editedProduct.image_url) {
      const imageUrl = await uploadImage(this.editedProduct.image_url);
      this.editedProduct.image_url = imageUrl;
    }
  }
  await updateDish(this.product.id, this.editedProduct);
  this.$emit('refresh-products');
}

  }
};
</script>

<style scoped>
.card-admin {
  padding-top: 30px;
  margin: 20px;
  border: none;
  background-color: transparent;
}

.form-group {
  margin-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
}

.apply-button,
.delete-button {
  margin: auto;
}

.image-preview {
  max-width: 100%;
  height: auto;
  display: block;
  margin: auto;
}

.card-body {
  color: var(--text-color);
  background-color: var(--secondary-color);
  box-shadow: var(--custom-box-shadow);
  border-radius: 20px;
}

.button-group {
  display: flex;
  margin-top: 40px;
  margin-bottom: 15px;
}
</style>
